/* Keep Shopify's real policy link in the approved short sentence. Consent stays native. */
(() => {
  const enhance = (banner) => {
    if (!banner || banner.dataset.clcRail) return;
    const paragraph = banner.querySelector('.shopify-pc__banner__body p');
    const policy = banner.querySelector('#shopify-pc__banner__body-policy-link');
    const first = paragraph?.firstChild;
    if (policy && first?.nodeType === Node.TEXT_NODE &&
        first.textContent.trim() === 'Cookies for preferences, analytics and personalised ads.') {
      first.textContent = ' ' + first.textContent.trim().slice('Cookies '.length);
      policy.textContent = 'Cookies';
      paragraph.insertBefore(policy, first);
    }
    if (!banner.querySelector('[id="shopify-pc__banner__body-title"]')) {
      banner.removeAttribute('aria-labelledby');
      banner.setAttribute('aria-label', 'Cookie choices');
    }
    banner.dataset.clcRail = 'ready';
  };
  enhance(document.getElementById('shopify-pc__banner'));
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        if (node.id === 'shopify-pc__banner') enhance(node);
        else enhance(node.querySelector('#shopify-pc__banner'));
      }
    }
  }).observe(document.body, { childList: true });
})();
